import Header from "./components/Header"
import Carousel from "./components/Carousel"
import WeeklyDeals from "./components/Departments"
import Circular from "./components/Circular"
import Events from "./components/Events"
import Newsletter from "./components/Newsletter"
import { Analytics } from "@vercel/analytics/react"

function App() {
  return (
    
        <div className="flex min-h-screen flex-col bg-gray-50 scroll-smooth">
        <main className="flex-1">
          <Analytics/>
          <Carousel />
          <Newsletter/>
          <hr className=" border-t border-gray-300" />
          <WeeklyDeals />
          <hr clasName="my-4 border-t border-gray-300" />
          <Events/>
          <hr className=" border-t border-gray-300" />
          <Circular />
        </main>
      </div>

  )
}

export default App
